export default class Vector2d {
  constructor(x = 0, y = 0) {
    this.x = x;
    this.y = y;
  }

  reset(x,y) {
    this.x = x;
    this.y = y;
  }

  add(x,y) {
    this.x += x;
    this.y += y;
  }

  addScaled(v, d) {
    this.x += v.x * d;
    this.y += v.y * d;
  }

  incrementBy(x,y) {
    this.x += x;
    this.y += y;
  }

  subtract(v) {
    this.x -= v.x;
    this.y -= v.y;
  }

  decrementBy(x,y) {
    this.x -= x;
    this.y -= y;
  }

  multiply(value) {
    this.x *= value;
    this.y *= value;
  }

  scaleBy(k) {
    this.x *= k;
    this.y *= k;
  }

  setFromDifference(v1, v2) {
    this.x = v1.x - v2.x;
    this.y = v1.y - v2.y;
  }

  lengthSquared() {
    return this.x * this.x + this.y * this.y;
  }

  getLength() {
    return Math.sqrt(this.lengthSquared());
  }

  getDistanceFrom(x,y) {
    const x2 = x;
    const y2 = y;
    const x1 = this.x;
    const y1 = this.y;
    const dx = x2 - x1;
    const dy = y2 - y1;
    return Math.atan2(dx, dy) / Math.PI * 180;
  }


  projection(vec) {
    const lenth = this.getLength();
    const lengthVec = vec.getLength();
    let proj = null;
    if (lenth === 0 || lengthVec === 0) {
      proj = 0;
    }
    else {
      proj = (this.x * vec.x + this.y * vec.y) / lengthVec;
    }
    return proj;
  }

  project(vector, v) {
    this.para(this.projection(vector), true, v);
  }

  para(u, positive, vector) {
    // eslint-disable-next-line no-param-reassign
    if (typeof positive === 'undefined') positive = true;
    const len = this.getLength();
    vector.reset(this.x, this.y);
    if (positive) {
      vector.multiply(u / len);
    }
    else {
      vector.multiply(-u / len);
    }
  }


  projection2(vec) {
    const length = this.getLength();
    const lengthVec = vec.getLength();
    let proj;
    if ((length === 0) || (lengthVec === 0)) {
      proj = 0;
    }
    else {
      proj = (this.x * vec.x + this.y * vec.y) / lengthVec;
    }
    return proj;
  }

  project2(vec) {
    return vec.para2(this.projection(vec));
  }

  para2(u, positive) {
    // eslint-disable-next-line no-param-reassign
    if (typeof positive === 'undefined') positive = true;
    const length = this.getLength();
    const vec = this.clone();
    if (positive) {
      vec.scaleBy(u / length);
    }
    else {
      vec.scaleBy(-u / length);
    }
    return vec;
  }

  clone() {
    return new Vector2d(this.x, this.x);
  }
}